import React from 'react'
import cn from 'classnames'

export const Submitting = ({ classNames, text = 'Submitting' }) => (
  <button className={cn(classNames)} disabled>
    <i className="spinner spinner-xs primary" />
    {` ${text}`}
  </button>
)

export default Submitting
